import { Brand } from 'constants/brand';

import { FirebaseService } from '../../service';

export class FirebaseServiceFm extends FirebaseService {
  constructor(name) {
    super(JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG_FM), Brand.FM, name);
  }
}
